import { Component, OnInit } from '@angular/core';
import {Api, User} from '../../providers';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-alertmodal',
  templateUrl: './alertmodal.page.html',
  styleUrls: ['./alertmodal.page.scss'],
})
export class AlertmodalPage implements OnInit {
  public value;
  public err:boolean=false;
  public sms:boolean=true;
  public emailCheck:boolean=true;
  public price:any;
    public data: {minprice:number,maxprice:number,fprice:number,email:string} = {
        minprice: 0,
        maxprice: 0,
        fprice: 0,
        email: '',
    };
  constructor(public api:Api, public user: User,public modalController: ModalController) {

  }
  public listLoding:boolean=true;
  public noties:any;
  ngOnInit() {
  this.value=this.price.price;
    this.getData()
  }
    async deleteAlert(notice) {
        await this.user.myLoading()
        this.api.post("notice", {type: "del", userKey: this.user.account.userKey,id:notice.id}).subscribe(res => {
            this.user.checkStatus(res,res=> {
                this.user.dismissLoading()
                if (res['status'] == "0") {
                    this.user.myAlert(res['message'],)
                } else {
                    this.user.myAlert(res['message'], null, ['تایید'], "خطا")
                }
                this.getData()
            },res=>{})
        },()=>{
            this.user.dismissLoading()
        });
    }
  async setAlert(){
      this.value=this.user.convertPersianNum(this.value)
      await this.user.myLoading()
      this.api.post("notice", {type: "add", userKey: this.user.account.userKey,email:this.data.email,value:this.value,wh:this.value>=this.price.price?"gt":"lt",sms:this.sms,emailCheck:this.emailCheck,pdid:this.price.priceData.id}).subscribe(res => {
          this.user.checkStatus(res,res=> {
              this.user.dismissLoading()
              if (res['status'] == "0") {
                  this.user.myAlert(res['message'],)
              } else {
                  this.user.myAlert(res['message'], null, ['تایید'], "خطا")
              }

              this.getData()
          },res=>{})
      },()=>{
          this.user.dismissLoading()
      });
  }
  changeCheck(type){
      if(type=="emailCheck"){
          this.emailCheck=!this.emailCheck;
      }else {
          this.sms=!this.sms;
      }
  }
    normalNum(){
        this.value=this.user.convertPersianNum(this.value);
        console.log(this.value/this.price.price*100)
        if(this.value/this.price.price*100<1 || this.value/this.price.price*100>200){
            this.err=true
        }else {
            this.err=false
        }
    }
  getData(){
      this.listLoding=true;
      this.api.post("notice", {type: "list", userKey: this.user.account.userKey}).subscribe(res => {
          this.user.checkStatus(res,res=> {
              this.noties = res["data"]
              this.listLoding = false;
          },res=>{})
      });
  }
   public dismissModal() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.modalController.dismiss({
            'dismissed': true
        });
    }
}
